/* eslint-disable no-console */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import useUserStore from '../../../store/userStore/userStore';

const DocumentOCRStatusPollingAPI = async (id: string = ''): Promise<any> => {
  const token = useUserStore.getState().userToken;

  if (!id) {
    return {};
  }

  try {
    const response = await axios.request({
      method: 'GET',
      url: `${API_BASE_URL}${API_ENDPOINT_JSON.AIDocumentOCRStatusPolling}/${id}`,
      headers: {
        Authorization: `Bearer ${token}`
      },
      params: {}
    });

    return response.data;
  } catch (err) {
    console.log('err:', err);
  }
};

export default DocumentOCRStatusPollingAPI;
